<template>
  <DataTable :data-model="'producttypes'"
             :display-name-plural="$t('entities.ProductType.Plural')"
             :display-name-singular="$t('entities.ProductType.Singular')"
             :permission-name="'ProductTypes'"
             :allow-delete="false"
             :exclude-fields="['id']" />
</template>
<script>
import DataTable from '@components/admin/DataTable';

export default {
  components: {
    DataTable
  }
};
</script>
<style scoped></style>
